import Layout from "components/Layout"
import PageHero from "components/PageHero"
import DynamicContent from "components/content/DynamicContent"
import { createApolloClient } from "utils/apollo"
import { buildListQuery } from "utils/blueprints/references"
import fetchCompany from "utils/fetch-company"
import fetchLocation from "utils/fetch-locations"
import fetchNav from "utils/fetch-nav"
import fetchPage from "utils/fetch-page"
import fetchSlugs from "utils/fetch-slugs"
import fetchSocialMedia from "utils/fetch-social-media"
import { replaceVariables } from "utils/replaceVariables"

function CatchAllPage({
  content = {},
  navs = {},
  company = {},
  locations,
  socialMediaLinks,
  caseStudies = [],
}) {
  const noPageHero =
    (!content.title_image &&
      !content.subtext &&
      !content.subtitle &&
      !content.headline) ||
    content.uri === "/"

  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      {!noPageHero && <PageHero data={content} />}
      <DynamicContent content={content} references={caseStudies} />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const { previewData } = context

  const apollo = createApolloClient(previewData?.token ?? null)

  const [referencesData, content, navs, company, locations, socialMediaLinks] =
    await Promise.all([
      apollo.query({
        query: buildListQuery(),
      }),
      fetchPage({
        apollo,
        slug: context.params?.slug,
        uri: !context.params?.slug ? "/" : null,
        isPreview: previewData?.unit,
      }),
      fetchNav(apollo, previewData?.unit),
      fetchCompany(apollo, previewData?.unit),
      fetchLocation(apollo, previewData?.unit),
      fetchSocialMedia(apollo, previewData?.unit),
    ])

  if (content?.errorCode) {
    console.error("page error:", content)
    throw new Error(content.message)
  }

  if (!content) {
    return { notFound: true }
  }

  if (referencesData.errors?.length) {
    throw new Error(referencesData.errors[0]?.message)
  }

  const references = (referencesData.data.entries.data || []).filter(Boolean)

  return {
    props: {
      content: await replaceVariables(content),
      navs,
      company,
      locations,
      socialMediaLinks,
      caseStudies: references.length ? await replaceVariables(references) : [],
    },
    // revalidate: 30,
  }
}

// Generate static paths for SSR
export const getStaticPaths = async () => {
  const allEntries = await fetchSlugs("pages")

  const paths = allEntries
    .map((entry) => ({
      params: { slug: entry.url.split("/").filter((s) => s) },
    }))
    .filter((path) => path.params.slug.length > 0)

  return {
    paths,
    fallback: false,
  }
}

export default CatchAllPage
